import React, { useState, useEffect } from "react";
import "./Sidemenu.css";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { useNavigate } from "react-router-dom";
import { useTheme } from "@mui/material";
import { useLocation } from "react-router-dom";
import UrlResolver from "../../utils/UrlResolver";
import CryptoJS from "crypto-js";
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { User_Info } from "../../Config";

const Sidemenu = ({
  open,
  setOpen,
  activeSubMenu,
  setActiveSubMenu,
  openMenus,
  setOpenMenus,
  menuMapping,
}) => {
  const location = useLocation();
  const { pathname } = location;
  const navigate = useNavigate();
  const theme = useTheme();
  const [lastActiveSubMenu, setLastActiveSubMenu] = useState(null);
  const [decryptedData, setDecryptedData] = useState(null);
  const handleClick = (menu, index) => {
    setActiveSubMenu((prevState) => {
      const newState = { ...prevState };
      const submenuPath = `/${menu}s[${index}].id`;
      newState[menu] = prevState[menu] === submenuPath ? null : submenuPath;
      if (newState[menu] !== null && open !== true) {
        setOpen(true);
      }
      if (newState[menu] !== null) {
        switch (menu) {
          case "entity":
            navigate(Entity[index].id);
            break;
          case "message":
            navigate(Messages[index].id);
            break;
          case "endpoint":
            navigate(Endpoints[index].id);
            break;
          case "alerts":
            navigate(Alerts[index].id);
            break;
          case "other":
            navigate(Others[index].id);
            break;
            case "dashboard":
              navigate("/dashboard");
          break;
          default:
            break;
        }
      }

      return newState;
    });
  };
  const handleSubMenuClick = (menu) => {
    console.log("menumenumenu",menu)
    if (openMenus.includes(menu)) {
      setOpenMenus(openMenus.filter((m) => m !== menu));
    } else {
      setLastActiveSubMenu(menu);
      setOpenMenus([menu]);
    }
    setOpen(true);
  };
  const GetpermissionValue = async() =>{
    try {
      const encryptedValue = localStorage.getItem("encryptedValue");
      if (encryptedValue) {
        const bytes = CryptoJS.AES.decrypt(encryptedValue, "encryptedValue");
        const decryptedData = await JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
        setDecryptedData(decryptedData);
      } else {
        console.error("No encrypted value found in localStorage.");
      }
    } catch (error) {
      console.error("Error in useEffect:", error);
    }
  }
  const handleLogout = () => {
    localStorage.clear();
      navigate("/login");
  };
  useEffect(() => {
    GetpermissionValue();
  }, []);

  useEffect(() => {
    if (open) {
      const activeSubmenu = Object.keys(menuMapping).find((submenuPath) =>
      pathname.includes(submenuPath)
    );
    
   
      if (activeSubmenu) {
        const parentMenu = menuMapping[activeSubmenu];

        setActiveSubMenu({
          ...activeSubMenu,
          [parentMenu]: `/${parentMenu}s[0].id`,
        });
        setOpenMenus([parentMenu]);
      }
    }
  }, [open, pathname]);

  useEffect(() => {
    if (!open) {
      setOpenMenus([]);
      setLastActiveSubMenu(null);
    } else {
      if (lastActiveSubMenu) {
        setOpenMenus([lastActiveSubMenu]);
      }
    }
  }, [open, lastActiveSubMenu]);

  useEffect(() => {
    if (open) {
      const activeSubmenu = Object.keys(menuMapping).find((submenuPath) =>
        pathname.includes(submenuPath)
      );

      if (activeSubmenu) {
        const parentMenu = menuMapping[activeSubmenu];
        console.log("this oneeeeeeee",parentMenu);
        setActiveSubMenu({
          ...activeSubMenu,
          [parentMenu]: 0, 
        });
        setOpenMenus([parentMenu]);
      }
    }
  }, [open, pathname]);
 
  const Dashboard = [
    { id: "/dashboard", name: "Dashboard" },
  ];
  const Entity = [
    {
      id: "/maintainentity",
      name: "Maintain Entities",
      visible: "Entity",
    },
    { id: "/entity_types", name: "Entity Types" ,visible: "EntityType" },
    { id: "/base_company", name: "Base Company", visible: "BaseCompany" },
  ];
  const Messages = [
    { id: "/message_types", name: "Message Types",visible: "MessageType" },
    { id: "/routing_status", name: "Routing Status",visible: "RoutingStatus" },
    { id: "/staus_code", name: "Status Codes",visible: "StatusCode" },
    { id: "/mapping_stream", name: "Mapping Streams",visible: "MappingStream" },
    { id: "/message_routing", name: "Message Routing" ,visible: "MessageRouting" },
  ];
  const Endpoints = [
    { id: "/Source_Endpoint", name: "Source Endpoints",visible: "Endpoint"  },
    { id: "/endpoint_type", name: "EndPoints Types" ,visible: "EndpointType" },
  ];
  const Alerts = [
    { id: "/handling_tracks", name: "Handling Tracks",visible: "AlertHandlingTrack" },
    { id: "/categories", name: "Categories" ,visible: "AlertCategory"},
    { id: "/alert_types", name: "Alert Types",visible: "AlertType" },
  ];
  const Others = [
    { id: "/latency_types", name: "Latency Types" ,visible: "LatencyType" },
    { id: "/log_records", name: "Message Records",visible: "LogRecords" },
    { id: "/stats_Tbnumber", name: "Stats By TB Number"},
    { id: "/Statistics", name: "Statistics"},
  ];
  const user = JSON.parse(localStorage.getItem(User_Info));
 let email="" 
 let name= user.name
 let userdp=user.userdp
  console.log("User_Info",user);
  const isMenuOpen = (menu) => openMenus.includes(menu);
  const isVisible = (menu) => decryptedData && decryptedData[menu] === true;
  
  return (
    <>
      <div className="parentdiv">
        <div
          style={{
            color: "var(--color-white)",
            height: "70%",
            overflowY: "auto",
          }}
        >
            <ul className="ulItem">
            <li className="mb-0">
              <div
                className={`menuitem ${open ? "" : ""}`}
                onClick={() => handleClick("dashboard")}
              >
                <img
                  src={UrlResolver("assets/Images/entity.svg")}
                  alt="Dashboard Logo"
                  className="iconImg"
                />
                <p style={{width:"81%",margin:0}}>Dashboard</p>
              </div>
            </li>
          </ul>
          {decryptedData && decryptedData.Entity_Main === true && (
          <ul className="ulItem">
            <li className="mb-0">
              <div
                className={`menuitem ${open ? "" : ""}`}
                onClick={() => handleSubMenuClick("entity")}
              >
                <img
                  src={UrlResolver("assets/Images/entity.svg")}
                  alt="Logo"
                  className="iconImg"
                />
                <p className="menutext">Entity</p>
                <div>
                  {" "}
                  {isMenuOpen("entity") ? (
                    <ArrowDropUpIcon />
                  ) : (
                    <ArrowDropDownIcon />
                  )}
                </div>
              </div>
              {isMenuOpen("entity") && (
                <div style={{ padding: "0.5rem 2.9rem" }}>
                  {Entity.map((item, index) => {
                    if (decryptedData[item?.visible]) {
                      return (
                        <li
                          key={index}
                          className={
                            open && pathname === item.id
                              ? "activeSubMenu"
                              : "liSubMenu"
                          }
                          onClick={() => handleClick("entity", index)}
                        >
                          {item.name}
                        </li>
                      );
                    } else {
                      return <></>;
                    }
                  })}
                </div>
              )}
            </li>
          </ul>)}
          {decryptedData && decryptedData.Message_Main === true && (
          <ul className="ulItem">
            <li className="mb-0">
              <div
                className={`menuitem ${open ? "" : ""}`}
                onClick={() => handleSubMenuClick("message")}
              >
                <img
                  src={UrlResolver("assets/Images/message.svg")}
                  alt="Logo"
                  className="iconImg"
                />
                <p className="menutext">Message</p>
                <div>
                  {" "}
                  {isMenuOpen("message") ? (
                    <ArrowDropUpIcon />
                  ) : (
                    <ArrowDropDownIcon />
                  )}
                </div>
              </div>
              {isMenuOpen("message") && (
                <div style={{ padding: "0.5rem 2.9rem" }}>
                  {Messages.map((item, index) => {
                    if (decryptedData[item?.visible]) {
                      return (
                    <li
                      key={index}
                      className={
                        open && pathname === item.id
                          ? "activeSubMenu"
                          : "liSubMenu"
                      }
                      onClick={() => handleClick("message", index)}
                    >
                      {item.name}
                    </li>);
                    } else {
                      return <></>;
                    }
                  })}
                </div>
              )}
            </li>
          </ul>)}
          {decryptedData && decryptedData.Endpoint_Main === true && (
          <ul className="ulItem">
            <li className="mb-0">
              <div
                className={`menuitem ${open ? "" : ""}`}
                onClick={() => handleSubMenuClick("endpoint")}
              >
                <img
                  src={UrlResolver("assets/Images/endpoint.svg")}
                  alt="Logo"
                  className="iconImg"
                />
                <p className="menutext">Endpoint</p>
                <div>
                  {" "}
                  {isMenuOpen("endpoint") ? (
                    <ArrowDropUpIcon />
                  ) : (
                    <ArrowDropDownIcon />
                  )}
                </div>
              </div>
              {isMenuOpen("endpoint") && (
                <div style={{ padding: "0.5rem 2.9rem" }}>
                  {Endpoints.map((item, index) => {
                    if (decryptedData[item?.visible]) {
                      return (
                    <li
                      key={index}
                      className={
                        open && pathname === item.id
                          ? "activeSubMenu"
                          : "liSubMenu"
                      }
                      onClick={() => handleClick("endpoint", index)}
                    >
                      {item.name}
                    </li>
                 );
                } else {
                  return <></>;
                }
              })}
                </div>
              )}
            </li>
          </ul>)}
          {decryptedData && decryptedData.Alert_Main === true && (
          <ul className="ulItem">
            <li className="mb-0">
              <div
                className={`menuitem ${open ? "" : ""}`}
                onClick={() => handleSubMenuClick("alerts")}
              >
                <img
                  src={UrlResolver("assets/Images/Alert.svg")}
                  alt="Logo"
                  className="iconImg"
                />
                <p className="menutext">Alerts</p>
                <div>
                  {" "}
                  {isMenuOpen("alerts") ? (
                    <ArrowDropUpIcon />
                  ) : (
                    <ArrowDropDownIcon />
                  )}
                </div>
              </div>
              {isMenuOpen("alerts") && (
                <div style={{ padding: "0.5rem 2.9rem" }}>
                  {Alerts.map((item, index) => {
                    if (decryptedData[item?.visible]) {
                      return (
                    <li
                      key={index}
                      className={
                        open && pathname === item.id
                          ? "activeSubMenu"
                          : "liSubMenu"
                      }
                      onClick={() => handleClick("alerts", index)}
                    >
                      {item.name}
                    </li>
                 );
                } else {
                  return <></>;
                }
              })}
                </div>
              )}
            </li>
          </ul>)}
     
          {/* {decryptedData && decryptedData.Others_Main === true && (
          <ul className="ulItem">
            <li className="mb-0">
              <div
                className={`menuitem ${open ? "" : ""}`}
                onClick={() => handleSubMenuClick("other")}
              >
                <img
                  src={UrlResolver("assets/Images/other.svg")}
                  alt="Logo"
                  className="iconImg"
                />
                <p className="menutext">Other</p>
                <div>
                  {" "}
                  {isMenuOpen("other") ? (
                    <ArrowDropUpIcon />
                  ) : (
                    <ArrowDropDownIcon />
                  )}
                </div>
              </div>
              {isMenuOpen("other") && (
                <div style={{ padding: "0.5rem 2.9rem" }}>
                  {Others.map((item, index) => {
                    console.log(item.name,"item");
                    if (decryptedData && decryptedData[item?.visible]) {
                      return (
                    <li
                      key={index}
                      className={
                        open && pathname === item.id
                          ? "activeSubMenu"
                          : "liSubMenu"
                      }
                      onClick={() => handleClick("other", index)}
                    >
                      {item.name}
                    </li>
                 );
                } else {
                  return <></>;
                }
              })} */}
              {decryptedData && decryptedData.Others_Main === true && (
            <ul className="ulItem">
              <li className="mb-0">
                <div
                  className={`menuitem ${open ? "" : ""}`}
                  onClick={() => handleSubMenuClick("other")}
                >
                  <img
                    src={UrlResolver("assets/Images/entity.svg")}
                    alt="Logo"
                    className="iconImg"
                  />
                  <p className="menutext">Others</p>
                  <div>
                    {isMenuOpen("other") ? (
                      <ArrowDropUpIcon />
                    ) : (
                      <ArrowDropDownIcon />
                    )}
                  </div>
                </div>
                {isMenuOpen("other") && (
                  <div style={{ padding: "0.5rem 2.9rem" }}>
                    {Others.map((item, index) => {
                      if (item.id === "/stats_Tbnumber" || item.id === "/Statistics" || decryptedData[item?.visible]) {
                        return (
                          <li
                            key={index}
                            className={
                              open && pathname === item.id
                                ? "activeSubMenu"
                                : "liSubMenu"
                            }
                            onClick={() => handleClick("other", index)}
                          >
                            {item.name}
                          </li>
                        );
                      } else {
                        return <></>;
                      }
                    })}
                </div>
              )}
            </li>
          </ul>)}
        </div>
        <div
          style={{
            color: "var(--color-white)",
            backgroundColor: "var(--color-primary)",
            height: "28%",
          }}
        >
            {/* <div
                className='menuitemsupport '
                onClick={() => navigate('/Support')}
              >
                <HelpOutlineIcon  />
                <p className="menutext">Support</p>
                
              </div>   */}
          <div className="userProfile">
            <img src={userdp} alt="User" className="userImg" />
            <div>
              <p className="userName">{name}</p>
              <p
                className="Logout"
                onClick={handleLogout}
              >
                Log-out
              </p>
              
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Sidemenu;
